import React, { Component } from "react";
import { connect } from "react-redux";
import logo from "../../static/images/rewardzlogo.svg";
import { withRouter } from "react-router-dom";
import * as LoginAction from "./Actions/LoginActions";
import {
  showEventModalAction,
  hideEventModalAction,
} from "../../Common/CommonStore/CommonActions";
import crypto from "crypto";
import config from "config";

class Login extends Component {
  constructor(props) {
    super(props);
    console.log(props.location.search);
    const query = props.location.search
      .substring(1)
      .split("&")
      .reduce(function (kv, q) {
        var pair = q.split("=");
        kv[pair[0].trim()] = pair[1].trim();
        return kv;
      }, {});

    console.log(query);

    this.state = {
      authenticating: false,
      query: query,
    };

    this.authenticate();
  }

  authenticate = async () => {
    this.setState({
      ...this.state,
      authenticating: true,
    });

    this.props.authenticateRequest(this.state.query);
  };

  render() {
    return (
      <div className="login-wraper">
        <div className="contaienr-fluid">
          <div className="login-container d-flex">
            <div className="login-icon">
              <img src={logo} title="logo" />
            </div>
            <div className="loginform d-flex">
              { this.state.authenticating 
                ? <h6>Authenticating ... please give us a moment</h6>
                : this.props.authenticateMessage
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    authenticateError: state.Login.authenticateError,
    authenticateMessage: state.Login.authenticateMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateRequest: (payload) =>
      dispatch(LoginAction.authenticateRequestAction(payload)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
